export const errors = {
    required: 'Required',
    invalid: 'Dates for goals must be in the future.'
};
